import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import GamesPage from './pages/GamesPage';
import RostersPage from './pages/RostersPage';
import LeagueLeadersPage from './pages/LeagueLeadersPage';
import './App.css';

function AppContent() {
  const location = useLocation();
  // Show game nav on /games, /rosters, and /league-leaders, hide on homepage
  const showGameNav = location.pathname === '/games' || location.pathname === '/rosters' || location.pathname === '/league-leaders';

  return (
    <Layout showGameNav={showGameNav}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/games" element={<GamesPage />} />
        <Route path="/rosters" element={<RostersPage />} />
        <Route path="/league-leaders" element={<LeagueLeadersPage />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <AppContent />
      </div>
    </Router>
  );
}

export default App;
